var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 0 7.9 11.5h2.9L8.4 22.9H0l2.4-11.4L7.8 0h4.4Zm13.1 0L21 11.5h2.9l-2.4 11.4h-8.4l2.4-11.4L20.9 0h4.4Z",
    fill: "currentColor"
  })));
};
export default SvgQuote;